import styled from "styled-components";

export const SaveGameButtonTitleBox = styled.span`
    line-height: 1;
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
`

